<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-icon :color="iconColor" v-on="on">
        {{ icon }}
      </v-icon>
    </template>
    <span>
      {{ tip }}
    </span>
  </v-tooltip>
</template>

<script>
  export default {
    props: {
      tip: {
        type: String,
        default: ''
      },
      icon: {
        type: String,
        default: ''
      },
      iconColor: {
        type: String,
        default: 'primaryiconbtn'
      }
    }
  }
</script>
